import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { ListEbook } from "../../api/index";
import Moment from 'react-moment';
import 'moment/locale/id';
import NumberFormat from 'react-number-format';
// import { Button } from 'reactstrap';


class EbookList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: true,
            listEbook: null,
            data: null
        }
    }

    componentDidMount() {  
        ListEbook().then(res => {
            console.log(res)
            this.setState({ data: res })
        })
    }

    onClickOrderHandler = () => {
        ListEbook().then(res => {
            this.setState({ data: res })
            // console.log(res[0].transactionId)
            // console.log(res[0].productId)
            const transId = res[0].transactionId;
            const productId = res[0].productId;
            this.props.history.push('/order/readebook/'+transId+'/'+productId); 
        })

       
        // this.props.history.push('/order/readebook/'+transId+'/'+productId);
    }


    render() {

        let listEbook = null;        
        if (this.state.data !== null) {
            listEbook = this.state.data.map((value, index) => (
                
                <div className="purchase-list-wrapper" onClick={(event)=>{this.onClickOrderHandler(event)}}>
                    {/* <div className="icon-list">
                        <i className="fas fa-shopping-bag"></i>
                    </div> */}
                   {/* <div className="list-product-pict contain-pict" style={{ background: `url(${value.Product.Pictures.url_small})` }} ></div> */}
                    <div className="purchase-description">
                        <div className="no-pesanan">{value.name}</div>
                        <div className="number-detail">
                            <div className="total">Total : <strong><NumberFormat value={value.subtotal} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                            </strong></div>
                            <div className="date">Tanggal Pembelian : <strong>
                                <Moment locale="id" format="D MMM YYYY">{value.createdAt}</Moment>
                            </strong></div>
                        </div>
                        {/* <div className="deadline">
                            Bayar sebelum <Moment locale="id" format="LLLL">{value.expireDate}</Moment>
                </div> */}
                        {/* <div className="payment-method">
                            <table>
                                <tr>
                                    <td>Metode Pembayaran</td>
                                    <td>:</td>
                                    <td>{value.Bank.bankname}</td>
                                </tr>
                                <tr>
                                    <td>Nomor Rekening</td>
                                    <td>:</td>
                                    <td>{value.Bank.norek}</td>
                                </tr>
                            </table>
                        </div> */}
                    </div>
                    <div className="purchase-action">
                        <div className="status">
                            Baca Ebook
                </div>
                    </div>
                </div>
            ))
        }

        return (
            <div className="purchase-list-wrapper">
                {/* <div className="purchase-list-header flex-row">
                    <div className="filter-label">Filter:</div>
                    <div className="filter-button-wrapper flex-row">
                        <Button>Menunggu Konfirmasi</Button>
                        <Button>Menunggu Konfirmasi</Button>
                        <Button>Menunggu Konfirmasi</Button>
                    </div>
                </div> */}
                <div className="purchase-list-body">
                    
                    {listEbook}

                </div>
            </div>
        )
    }
}

export default withRouter(EbookList);